import { render } from "./SubmitOther.vue?vue&type=template&id=1f8c934a"
import script from "./SubmitOther.vue?vue&type=script&lang=js"
export * from "./SubmitOther.vue?vue&type=script&lang=js"

import "./SubmitOther.vue?vue&type=style&index=0&id=1f8c934a&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__